import React from 'react';

/**
 * The Slightor mark — same vector as slightercrm/src/components/brand/BrandMark.tsx
 * and public/favicon.svg, so the console, the CRM and the browser tab match.
 */
export const BrandMark: React.FC<{ size?: number; tone?: 'gold' | 'white'; glow?: boolean; className?: string }> =
  ({ size = 20, tone = 'gold', glow = false, className }) => {
    const fill = tone === 'white' ? '#FFFFFF' : 'var(--color-primary, #C8A55B)';
    return (
      <svg width={size} height={size} viewBox="0 0 64 64" className={className} aria-hidden focusable="false">
        {glow && (
          <defs>
            <radialGradient id="slightor-console-glow" cx="50%" cy="50%" r="50%">
              <stop offset="0%" stopColor={fill} stopOpacity="0.55" />
              <stop offset="100%" stopColor={fill} stopOpacity="0" />
            </radialGradient>
          </defs>
        )}
        {glow && <circle cx="30" cy="34" r="22" fill="url(#slightor-console-glow)" />}
        <path fill={fill} d="M30 4 C31.6 22 33.4 30.2 52 34 C33.4 37.8 31.6 46 30 62 C28.4 46 26.6 37.8 8 34 C26.6 30.2 28.4 22 30 4 Z" />
        <path fill={fill} d="M50 10 C50.5 15 51.2 17.6 57 18.5 C51.2 19.4 50.5 22 50 27 C49.5 22 48.8 19.4 43 18.5 C48.8 17.6 49.5 15 50 10 Z" />
      </svg>
    );
  };

/** Dark rounded tile holding the mark — the app icon used in both sidebars. */
export const BrandTile: React.FC<{ size?: number }> = ({ size = 36 }) => (
  <span
    className="flex shrink-0 items-center justify-center rounded-xl bg-[#1A1A1A]"
    style={{ width: size, height: size }}
  >
    <BrandMark size={Math.round(size * 0.56)} />
  </span>
);
